import { Exclude, Expose } from 'class-transformer';

@Exclude()
export class AgreementGroupApiModel {
  id: string;

  name: string;
}
